import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer, persistStore, FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import otpReducer from "./slices/otpSlice";
import orderReducer from "./slices/orderSlice";
import bankReducer from "./slices/bankSlice";
import loadingReducer from "./slices/loadingSlice";
import layoutReducer from "./slices/layoutSlice";

import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";

const rootReducers =  combineReducers({
  auth: authReducer,
  otp: otpReducer,
  loading: loadingReducer,
  layout: layoutReducer,
  order: orderReducer,
  bank: bankReducer,
});

const persistConfig = {
  key: "default",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      
    }),
    
});

export const persistor = persistStore(store);

type RootState = ReturnType<typeof store.getState>
type AppDispath = typeof store.dispatch

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = () => useDispatch<AppDispath>()


